import { useState } from 'react';
import classnames from 'classnames';
import { useSwipeable } from 'react-swipeable';
import lang from 'constants/lang';
import translations from 'constants/artwork';
import styles from './ArtworkMap.module.scss';

export const ArtworkMapItem = ({ artwork, current, onClick }) => (
  <div className={ classnames(styles.artwork, styles[artwork], current === artwork && styles.active) } onClick={ onClick }>
    <div className={ styles.wrapper }>
      <div className={ styles.model }>
        <img src={ `${process.env.PUBLIC_URL}/images/argallery/artwork/${artwork}.png` } alt="" />
      </div>
      <div className={ styles.tag }>
        <img src={ `${process.env.PUBLIC_URL}/images/argallery/tags/${lang}/default/${artwork}.png` } alt="" className={ styles.default } />
        <img src={ `${process.env.PUBLIC_URL}/images/argallery/tags/${lang}/hover/${artwork}.png` } alt="" className={ styles.hover } />
      </div>
    </div>
  </div>
);

function ArtworkMap({ currentArtworkMapItem, setArtworkMapItem }) {
  const [showAsiaMap, setShowAsiaMap] = useState(true);
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      !showAsiaMap && setShowAsiaMap(true);
    },
    onSwipedRight: () => {
      showAsiaMap && setShowAsiaMap(false);
    },
    preventScrollOnSwipe: true
  });

  const setCurrentArtwork = (artwork) => {
    if (currentArtworkMapItem) {
      setArtworkMapItem(null);
    } else {
      setArtworkMapItem(artwork);
    }
  };

  return (
    <div
      className={ classnames(styles.map, showAsiaMap && styles.mapAsia) }
      style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/images/argallery/map.png')` }}
      {...swipeHandlers}
      onClick={ () => currentArtworkMapItem !== null && setCurrentArtwork(null) }
    >
      <div className={ classnames(styles.instruction, styles.tapToViewDetails) }>
        { translations.tapToViewDetails }
      </div>
      <div className={ classnames(styles.instruction, styles.swipeToUnlockNorthAmericaMap) }>
        <img src={ `${process.env.PUBLIC_URL}/images/argallery/swipe-arrows-left.png` } alt="" className={ styles.swipeArrows } />
        <span>{ translations.swipeToUnlockNorthAmericaMap }</span>
      </div>
      <div className={ classnames(styles.instruction, styles.swipeToUnlockAsiaMap) }>
        <span>{ translations.swipeToUnlockAsiaMap }</span>
        <img src={ `${process.env.PUBLIC_URL}/images/argallery/swipe-arrows-right.png` } alt="" className={ styles.swipeArrows } />
      </div>
      {
        [
          'keithlam',
          'stephlau',
          'innovationpin',
          'yarliallison',
          'ericbot404',
          'franknitty',
        ].map((artwork, index) => (
          <ArtworkMapItem
            key={ `artwork-map-${index}` }
            artwork={ artwork }
            current={ currentArtworkMapItem }
            onClick={ () => setCurrentArtwork(artwork) }
          />
        ))
      }
    </div>
  );
}

export default ArtworkMap;